export const formatShareMoney = (amount, currency = 'INR') => {
  if (amount == null || amount === '') return '—';
  const value = Number(amount);
  if (!Number.isFinite(value)) return String(amount);
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency, maximumFractionDigits: 2 }).format(value);
  } catch {
    return `${currency} ${value.toFixed(2)}`;
  }
};

export const formatSignedShareMoney = (amount, currency = 'INR') => {
  const value = Number(amount) || 0;
  const formatted = formatShareMoney(Math.abs(value), currency);
  if (value < -0.004) return `-${formatted}`;
  return formatted;
};

export const sortShareBalances = (balances = []) => {
  const owed = [];
  const owes = [];
  const settled = [];
  balances.forEach((row) => {
    const net = Number(row?.net) || 0;
    if (net > 0.004) owed.push(row);
    else if (net < -0.004) owes.push(row);
    else settled.push(row);
  });
  owed.sort((a, b) => Number(b.net) - Number(a.net));
  owes.sort((a, b) => Number(a.net) - Number(b.net));
  return [...owed, ...owes, ...settled];
};

export const findMyShareBalance = (balances = [], userId) => {
  if (userId == null) return null;
  return balances.find((row) => String(row.userId) === String(userId)) || null;
};

export const isSettlementEntry = (entry) =>
  String(entry?.entryKind || '').toUpperCase() === 'SETTLEMENT';

export const settlementReceiver = (entry) => {
  const share = Array.isArray(entry?.shares) ? entry.shares[0] : null;
  return share || null;
};
